import FewerComparablesReason from './FewerComparablesReason';

export {FewerComparablesReason};
export default FewerComparablesReason;
